module.exports = "/_next/static/images/dashboard-b54eab8b6b47fc72d70808a5bd0d7e91.svg";